<template>
  <v-dialog
    v-model="dialog"
    width="450"
    @keydown.enter="handleEnterKey"
  >
    <template #activator="{on}">
      <slot
        :on="on"
      ></slot>
    </template>
    <v-card
      :loading="loading"
    >
      <v-card-title>
        <v-img
          v-if="options.type === 'question'"
          height="200"
          contain
          :src="require('@/assets/question.svg')"
        />
        <v-img
          v-else
          height="200"
          contain
          :src="require('@/assets/warning.svg')"
        />
      </v-card-title>
      <v-card-text
        class="text-center"
      >
        <div class="subtitle-1 font-weight-bold">{{options.title}}</div>
        <div>{{options.subtitle}}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="secondary"
          style="text-transform: none"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          :color="options.type === 'question' ? 'info' : 'error'"
          style="text-transform: none"
          @click="handleConfirmClick"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    loading: false,
    callback: null,
    options: {
      type: 'question',
      title: 'Are you sure?'
    }
  }),
  methods: {
    show (callback, options = null) {
      this.callback = callback
      this.options = {
        ...this.options,
        ...options
      }
      this.dialog = true
    },
    handleEnterKey (event) {
      if (this.dialog && !this.loading) {
        event.preventDefault()
        this.handleConfirmClick()
      }
    },
    async handleConfirmClick () {
      this.loading = true
      await this.callback()
      this.dialog = false
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/confirm-dialog.vue